// @flow
/* eslint-disable no-console */

import { useEffect } from 'react';

import { type PaymentSpec } from '@tectonics/prs/payment-spec';
import { type LookAndFeel } from '@tectonics/look-and-feel';

import { analyzeLookAndFeelAgainstSpec, type LookAndFeelAnalysis } from '@tectonics/look-and-feel-analyzer';

export function useLookAndFeelAnalyzer(lookAndFeel: ?LookAndFeel, spec: ?PaymentSpec) {
  useEffect(
    () => {
      if (isAnalyzableEnviroment() && lookAndFeel && spec) {
        const analysis = analyzeLookAndFeelAgainstSpec(lookAndFeel, spec);
        reportAnalysis(analysis);
      }
    },
    [lookAndFeel, spec],
  );
}

function isAnalyzableEnviroment(): boolean {
  return ENV_CONSTANTS.ENV === 'development';
}

function reportAnalysis(analysis: LookAndFeelAnalysis) {
  if (analysis.unsupportedPaymentMethods.length > 0) {
    const unsupportedPaymentMethodList = analysis.unsupportedPaymentMethods.map(code => `- ${code}`).join('\n');
    console.warn(`Look and Feel "${analysis.lookAndFeel.displayName}" does not support the following payment methods:\n${unsupportedPaymentMethodList}`);
  }

  if (analysis.unsupportedFeatures.length > 0) {
    const unsupportedFeatureList = analysis.unsupportedFeatures.map(name => `- ${name}`).join('\n');
    console.warn(`Look and Feel "${analysis.lookAndFeel.displayName}" does not support the following features:\n${unsupportedFeatureList}`);
  }

  if (analysis.unsupportedTraits.length > 0) {
    const unsupportedTraitList = analysis.unsupportedTraits.map(([trait, featureName]) => `- ${trait} [feature: ${featureName}]`).join('\n');
    console.warn(`Look and Feel "${analysis.lookAndFeel.displayName}" does not support the following traits of features:\n${unsupportedTraitList}`);
  }
}
